"use client";

import {
    readCookie,
    getUTMParams,
    setCookie,
} from 'helpers/Helper';
import { useEffect } from 'react';

export const UTMCookie = () => {
    const setUTMTrackingCookie = () => {
        let queryString = window.location.search,
            utmParams = getUTMParams(queryString);
        if (utmParams && utmParams?.referral_source?.toLowerCase() === "bam") {
            utmParams.referral_source = "EBBGOAAAAV";
        }
        if (utmParams && JSON.stringify(utmParams) !== readCookie("utm_params")) {
            setCookie("utm_params", JSON.stringify(utmParams));
        }
    };
    useEffect(() => {
        setUTMTrackingCookie();
    }, [])
}
